module.exports = __webpack_public_path__ + "static/media/Enduro.1e130373.svg";